import { render, staticRenderFns } from "./chat-for-user-suggestion-list.html?vue&type=template&id=6ae32243&scoped=true&external"
import script from "./chat-for-user-suggestion-list.js?vue&type=script&lang=js&external"
export * from "./chat-for-user-suggestion-list.js?vue&type=script&lang=js&external"
import style0 from "./chat-for-user-suggestion-list.scss?vue&type=style&index=0&id=6ae32243&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae32243",
  null
  
)

export default component.exports